module.exports = __webpack_public_path__ + "img/male.eab26f29.jpg";